import { BaseController } from '../../base/controller';

class InfoCheckboxController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  $onInit() {
    this.showInfo = false;
  }

  $onChanges(changes) {
    if (changes.isDisabled && changes.isDisabled.currentValue === true) {
      this.model = false;
    }
  }
}

export default InfoCheckboxController;



// WEBPACK FOOTER //
// ./src/app/common/ui/infoCheckbox/infoCheckbox.controller.js